var React = require('react');

function Ring (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.69917 63.3776L4.69937 63.3768C15.7807 20.2756 55.144 -6.56711 92.5226 3.06496L92.5261 3.06586C129.9 12.5508 151.358 55.1165 140.277 98.0712C129.196 141.023 89.8322 167.87 52.4499 158.383C15.076 148.898 -6.38226 106.332 4.69917 63.3776Z","stroke":"currentColor","strokeWidth":"2"}));
}

Ring.defaultProps = {"viewBox":"0 0 145 162","fill":"none"};

module.exports = Ring;

Ring.default = Ring;
